import { useRef, type ReactNode } from 'react'
import { cn } from '@/lib/utils'

// Adapted from React Bits SpotlightCard (https://reactbits.dev/components/spotlight-card).
// Keep only the pointer light; the portfolio supplies the surface and border.
export function SpotlightCard({ children, className }: { children: ReactNode; className?: string }) {
  const lightRef = useRef<HTMLSpanElement>(null)

  return (
    <div
      className={cn('relative isolate overflow-hidden', className)}
      onPointerMove={(event) => {
        if (event.pointerType !== 'mouse' || !window.matchMedia('(hover: hover) and (prefers-reduced-motion: no-preference)').matches) return
        const rect = event.currentTarget.getBoundingClientRect()
        const light = lightRef.current
        if (!light) return
        light.style.background = `radial-gradient(260px circle at ${event.clientX - rect.left}px ${event.clientY - rect.top}px, rgb(var(--accent) / 0.07), transparent 75%)`
        light.style.opacity = '1'
      }}
      onPointerLeave={() => {
        if (lightRef.current) lightRef.current.style.opacity = '0'
      }}
    >
      <span
        ref={lightRef}
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 -z-10 opacity-0 transition-opacity duration-200 motion-reduce:hidden"
      />
      {children}
    </div>
  )
}
